import { DOCUMENT, inject, Service } from '@angular/core';

interface ClarityFunction {
  (...args: unknown[]): void;
  // eslint-disable-next-line custom-rules/prefer-interface-property-readonly -- reassigned in #createClarityScript
  q?: unknown[][];
}

declare global {
  interface Window {
    // eslint-disable-next-line custom-rules/prefer-interface-property-readonly -- reassigned in #createClarityScript
    clarity: ClarityFunction;
  }
}

@Service()
export class ClarityService {
  readonly #document = inject(DOCUMENT);

  initialize(key: string): void {
    this.#createClarityScript(key);
  }

  #createClarityScript(key: string): void {
    const script = this.#document.createElement('script');

    script.type = 'text/javascript';
    script.async = true;
    script.src = `https://www.clarity.ms/tag/${key}`;
    this.#document.body.appendChild(script);

    window.clarity = window.clarity || ((...args: unknown[]): void => {
      (window.clarity.q = window.clarity.q || []).push(args);
    });
  }
}
